<template>
  <div class="dropdown">
    <div @click="isAuthMenuOpen = !isAuthMenuOpen">
      <slot></slot>
    </div>

    <ul
      v-if="isAuthMenuOpen"
      class="dropdown-list"
      v-click-outside="closeMenu"
    >
      <li class="arrow" :class="position"></li>

      <li class="desktop-only">
        <a :href="dashboardUrl" :target="dashboardTarget">
          <i class="fa-regular fa-dashboard"></i>
          <span>My Account</span>
        </a>
      </li>

      <li>
        <a href="#" @click="goToPage('Event Switcher')">
          <i class="fa-regular fa-list-tree"></i>
          <span>Switch Event</span>
        </a>
      </li>

      <li class="desktop-only" v-if="showUpgradeTicketMenu">
        <a href="#" @click="goToPage('Upgrade Ticket')">
          <i class="fa-regular fa-puzzle"></i>
          <span>Upgrade Ticket</span>
        </a>
      </li>

      <li>
        <a href="#" @click="logOut">
          <i class="fa-regular fa-arrow-left-from-line"></i>
          <span>Log out</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTES } from "../../../router";
import { resetAuthHeadersAndLocalStore } from "../../../api";

export default {
  props: ['position'],
  data() {
    return {
      homePageLink: ROUTES.MAIN_LAYOUT.replace(':attendeeId', this.$route.params.attendeeId),
      isOpen: false,
      isAuthMenuOpen: false,
      attendeeId: this.$route.params.attendeeId,
    };
  },
  computed: {
    ...mapGetters("attendeeStore", [
      "attendee",
      "showUpgradeTicketMenu"
    ]),

    isImpactCeOrganization() {
      return this.attendee?.organization_id === 1;
    },

    dashboardUrl() {
      return this.isImpactCeOrganization
        ? 'https://www.impactce.com/dashboard'
        : this.attendee?.dashboard_url;
    },

    dashboardTarget() {
      return this.isImpactCeOrganization ? '_self' : '_blank';
    },
  },
  methods: {
    closeMenu() {
      if (this.isAuthMenuOpen) {
        this.isAuthMenuOpen = false;
      }
    },

    async logOut(e) {
      e.preventDefault();

      await resetAuthHeadersAndLocalStore();

      this.goToPage('Access');
    },

    goToPage(name) {
      this.$router.push({ name: name });
    }
  },
}
</script>

<style scoped lang="scss">
.dropdown{
  position: relative;
  cursor: pointer;
}

.dropdown-list {
  position: absolute;
  border-radius: 6px;
  top: 43px;
  right: var(--attendee-gap-sm);
  background: white;
  list-style: none;
  padding: var(--attendee-gap-md);
  box-shadow: 0 3px 10px 0px rgb(0 0 0 / 16%);
  width: auto;
  min-width: 100%;
  z-index: 3;

  .arrow {
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    top: -9px;
    left: 60px;
    background: white;
    border-top: 1px solid white;
    border-left: 1px solid white;
    z-index: 2;
    transform: rotate(45deg);

    &.right {
      left: initial;
      right: var(--attendee-gap-md);
    }

    &.center {
      left: calc(50% - 10px);
    }
  }

  > li {
    white-space: nowrap;
    list-style: none;
    font-size: 13px;
    display: grid;
    width: 100%;

    &:hover {}

    i,
    svg {}

    a {
      grid-gap: var(--attendee-gap-md);
      padding: var(--attendee-gap-xs) 0;
      font-weight: 600;
      text-decoration: none;
      text-transform: initial;
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
    }
  }
}
</style>
